import {BaseModel} from '@/models/base.model.js'

/**
 * Organization model
 */
export class Organization extends BaseModel {
}
